import UI from "./base/UI";
import {onRollingNumber} from "../functions/simple.ui";
import { isA11yCheckVersion } from "../functions/a11y.ui";

import Popup from "./base/Popup";

 //
 //한번에 이자받기 화면에서  '밀어서' 이자받는 모션 이벤트였는데  '클릭' 이벤트로 변경 
 //frontUI.earnInterest()로 변경  // 관련지라 CHPFMTASK-1464 
 //
class SwipeToAction extends UI {

    defaults = {
        slideRatio: '50'
    };

    options = {
        drags: {
            dx: 0,  // 최초 drag 좌표
            cx: 0,  // 현재 drag 좌표
            ratio: 0,  // slide 포인트(%)
            acc: 0.1,
            rect: null,
            range: [0,0],
            steps: [],
        }
    }

    touchEvents = {
        start: false,
        move: false,
        tapInfo: {
            type: null,
            x: -1,
            y: -1,
            time: 0
        }
    }

    swipeBtn;
    swipeWrapper;
    swipeArea;
    swipeDirection;
    uiPopup;
    uiLottie;
    coinDiv;
    prevStepIdx;
    rafId;
    timerId;
    reflow;
    isSlideComplete;
    onSlideComplete;
    isTouchEvent;
    bounceCounter = 0;
    doubleTapDuration = 1000;
    tapThreshold = 5;
    androidCheck;

    constructor(el, options) {
        super('swipeToAction', el);

        this.init(el, options);
    }

    init(el, options) {
        this.defaults = {...this.defaults, ...this.options};

        this.render();
    }

    update() {        
        this.defaults.drags.rect = this.swipeBtn.getBoundingClientRect();
        this.defaults.drags.dx = Math.floor(this.defaults.drags.rect.left);

        const rect = this.swipeWrapper.getBoundingClientRect();
        this.defaults.drags.range = [Math.floor(rect.left - this.defaults.drags.dx), Math.floor(rect.right - this.defaults.drags.dx - this.defaults.drags.rect.width)];
        this.defaults.drags.steps = this.defaults.swipeStep && JSON.parse(this.defaults.swipeStep);
        this.defaults.drags.ratio = Math.floor(this.defaults.drags.range[1] * JSON.parse(this.defaults.slideRatio) / 100);

        if(this.defaults.repeatBounce == 'true'){
            this.startBounce();
        }

        if(this.uiPopup && this.hasCounterNum().length){
            onRollingNumber(() => {
                this.hasLottie().length && this.playLottie();
            });
        }
    }

    render() {
        if(!this.swipeBtn){
            this.swipeWrapper = this.el;
            this.swipeBtn = document.querySelector(`.ui-swipeAction .${this.swipeWrapper.dataset.swipeBtn}`); // 밀어서이자받기 버튼이 기존페이지에 있는 다른 클래스랑 같은 클래스 wrap > button 으로 변경
            // this.swipeBtn = document.querySelector(`.${this.swipeWrapper.dataset.swipeBtn}`);
            this.swipeArea = document.querySelector(`.${this.swipeWrapper.dataset.swipeArea}`);
            this.uiPopup = this.$el.closest('.ui-popup').data('ui');
            this.swipeConfirm = this.swipeWrapper.querySelector('.plus-box-layer.step2');

            this.defaults = {...this.defaults, ...this.swipeWrapper.dataset};

            this.update();

            setTimeout(() => {
                if(!this.uiPopup) return false;

                if(this.hasLottie().length){
                    this.uiLottie = $(this.hasLottie()).data('ui');
                }

                if(this.uiPopup.$popup.is(':visible')){
                    this.update();
                }
            }, 500);
        }
        this.androidCheck = this.deviceCheck()
        this.detachEvents();
        this.attachEvents();

        if(isA11yCheckVersion()){
            this.isA11yCreateSlideLiveArea();
        }
    }

    attachEvents() {
        // console.log('this.swipeArea:',this.swipeArea,' || this.swipeArea.parentElement:',this.swipeArea.parentElement)
        const swipeParent = this.swipeArea.parentElement;
        this.$el.on(`click${this.eventId}`, this.swipeBtn, this.onSwipeHandler.bind(this));
        this.$el.on(`touchstart${this.eventId}`, this.swipeBtn, this.onSwipeHandler.bind(this));
        this.$el.on(`touchend${this.eventId}`, this.swipeBtn, this.onSwipeHandler.bind(this));
        this.$el.on(`touchmove${this.eventId}`, this.swipeBtn, this.onSwipeHandler.bind(this));

        this.$el.on(`touchstart${this.eventId}`, this.swipeBtn, (e) => {
            if(!e.target.classList.contains('btn-arrow')) return false;
            this.touchEvents.start = true;
            this.defaults.repeatBounce == 'true' && this.stopBounce();
        });

        this.$el.on(`touchmove${this.eventId}`, this.swipeBtn, (e) => {
            if(!e.target.classList.contains('btn-arrow')) return false;
            if(!this.touchEvents.start) return;
            this.touchEvents.move = true;
        });
        
        this.$el.on(`touchend${this.eventId}`, this.swipeBtn, (e) => {
            if(!e.target.classList.contains('btn-arrow')) return false;
            if(this.touchEvents.start && !this.touchEvents.move){
                // console.log('tap event...');
                this.swipeBtn.classList.remove('active');
                this.swipeArea.parentElement.classList.remove('active');
                this.defaults.repeatBounce == 'true' && this.bounceInEffects(3000);
            }
            this.touchEvents.start = false;
            this.touchEvents.move = false;
            this.isTouchEvent = false;
        });

        
        // this.$el.on(`click${this.eventId}`, this.swipeBtn, (e) => {
        //     // console.log('click', this.isSlideComplete)
        //     if(!e.target.classList.contains('btn-arrow')) return false;
        //     this.defaults.repeatBounce == 'true' && this.stopBounce();
        //     this.reflow = true;
        //     this.isSlideComplete = 1;
        //     this.defaults.repeatBounce == 'true' && this.stopBounce();
        //     this.swipeArea.parentElement.classList.add('active');
        //     this.slideRender();            
        // });
        this.$el.on(`touchstart${this.eventId}`, swipeParent, (e) => {
            // console.log('start',this.$el,'swipeParent:',swipeParent)
            this.touchEvents.start = true;
        });

        this.$el.on(`touchmove${this.eventId}`, swipeParent, (e) => {
            if(!this.touchEvents.start) return;
            this.touchEvents.move = true;
        });

        this.$el.on(`touchend${this.eventId}`, swipeParent, (e) => {
            console.log('touchend swiperParent : ', swipeParent)
            // console.log('touchend', '| swipeParent : ',swipeParent, ' | e.target : ',e.target)
            if(e.target != swipeParent) return false;

            let nX = e.changedTouches[0].pageX;
            let nY = e.changedTouches[0].pageY;
            let nTime = e.timeStamp;
            console.log('this.touchEvents.start : ', this.touchEvents.start , '| this.touchEvents.move : ', this.touchEvents.move )
            if(this.touchEvents.start && !this.touchEvents.move){
                // 이전 tap 이벤트와 시간차가 1000ms 이하일 경우
                console.log('this.touchEvents.tapInfo.type : ', this.touchEvents.tapInfo.type)
                if(this.touchEvents.tapInfo.type == 'tap' && (nTime - this.touchEvents.tapInfo.time) <= this.doubleTapDuration){
                    if( (Math.abs(this.touchEvents.tapInfo.x - nX) <= this.tapThreshold) && (Math.abs(this.touchEvents.tapInfo.y - nY) <= this.tapThreshold) ){
                        this.reflow = true;
                        this.isSlideComplete = 1;
                        this.defaults.repeatBounce == 'true' && this.stopBounce();
                        this.swipeArea.parentElement.classList.add('active');
                        this.slideRender();            
                        // console.log('double tap event...');
                        /*! s: FETASK-a11y page 밀어서 이자받기 접근성 추가 v.1.0.0 */
                        isA11yCheckVersion() && this.isA11ySlideLiveText('start');
                        /*! e: FETASK-a11y page 밀어서 이자받기 접근성 추가 v.1.0.0 */
                    }
                }else{
                    this.touchEvents.tapInfo.type = 'tap';
                    this.touchEvents.tapInfo.x = nX;
                    this.touchEvents.tapInfo.y = nY;
                    this.touchEvents.tapInfo.time = nTime;
                    // console.log('tap event2...');
                }
            }else{
                this.initTapInfo();
            }

            this.touchEvents.start = false;
            this.touchEvents.move = false;
        });

        if (this.androidCheck) {
            const  that = this;
            $(this.$el).on('click.androidClick' , function(e){
                // console.log('안드로이드 접근성 클릭')
                console.log('androidClick')
                e.stopPropagation();
                that.reflow = true;
                that.isSlideComplete = 1;
                that.defaults.repeatBounce == 'true' && that.stopBounce();
                that.swipeArea.parentElement.classList.add('active');
                that.slideRender();
                // console.log('double tap event...');
                /*! s: FETASK-a11y page 밀어서 이자받기 접근성 추가 v.1.0.0 */
                isA11yCheckVersion() && that.isA11ySlideLiveText('start');
                /*! e: FETASK-a11y page 밀어서 이자받기 접근성 추가 v.1.0.0 */
            })
        }
    }

    hasLottie(){
        return this.uiPopup.$popup.find('.ui-lottie');
    }

    playLottie(){
        // console.log('play lottie...');
        this.uiLottie.defaults.lottieAni.play();
    }

    stopLottie(){
        this.uiLottie.defaults.lottieAni.stop();
    }

    switchLottie(){
        this.uiLottie.el.dataset.filename = 'giftbox_open';
        this.uiLottie.el.dataset.auto = 'false';
        this.uiLottie.el.dataset.loop = 'false';
        this.uiLottie.el.classList.replace('ani-step1', 'ani-step2');        
        this.uiLottie.update(); 
        this.uiLottie.defaults.lottieAni.onEnterFrame = () => {
            // console.log('onenter')
            if(this.uiPopup.el.classList.contains('ui-full-change')){
                // this.uiLottie.defaults.lottieAni.play();
            }else{
                this.uiLottie.defaults.lottieAni.currentFrame = 1;
                this.uiLottie.defaults.lottieAni.pause();
            }
        }
    }

    initTapInfo(){
        this.touchEvents.tapInfo.type = null;
    }

    bounceInEffects(timer){
        const moveX = this.defaults.drags.range[1] * 10 / 100;
        this.swipeBtn.classList.add('bounce-in');
        this.swipeBtn.style.transform = `translateX(${moveX}px)`;
        
        let transitionDuration = Number(window.getComputedStyle(this.swipeBtn).transitionDuration.split('s')[0])*1000;    
        setTimeout(() => {
            let updateTimer = this.bounceCounter > 0 ? timer : transitionDuration + timer;
            this.swipeBtn.style.transform = `translateX(${this.defaults.drags.range[0]}px)`;
            clearTimeout(this.timerId);

            this.bounceCounter++;
            this.startBounce(updateTimer);
        }, transitionDuration);
    }     

    startBounce(utimer){
        if(this.isTouchEvent) return false;
        let timer = utimer || 3000;

        this.timerId = setTimeout(() => {
            // console.log(`${timer/1000}초가 지남....`);
            this.bounceInEffects(timer);
        }, timer);
    }

    stopBounce(){
        this.isTouchEvent = true;
        this.bounceCounter = 0;
        this.swipeBtn.classList.remove('bounce-in');
        this.timerId && clearTimeout(this.timerId);
    }

    coinEffectsInSlide(){
        if(this.uiPopup.el.querySelectorAll('.coin-bottom-to-up').length == this.defaults.drags.steps.length) return false;

        let percent = parseInt(this.defaults.drags.cx * 100 / this.defaults.drags.range[1]);
        const stepIdx = this.defaults.drags.steps.filter(step => percent > step);
        
        stepIdx.length && this.addCoins(stepIdx);
    }

    addCoins(stepIdx){
        const currentIdx = stepIdx.length-1;
        if(currentIdx != this.prevStepIdx){
            this.prevStepIdx = currentIdx;
            this.coinDiv = `<div class="coin-bottom-to-up" style="left: ${this.defaults.drags.steps[currentIdx]}%;"><i class="ico-plusbox-coin" aria-hidden="true"></i></div>`;
            this.uiPopup.$popup.find('.popup-group').append(this.coinDiv);

            if(this.onActionComplete != null){
                this.onActionComplete();
            }    
        }
    }

    removeCoins(){
        const coinDivs = this.uiPopup.el.querySelectorAll('.coin-bottom-to-up');
        [...coinDivs].forEach(coin => this.uiPopup.el.querySelector('.popup-group').removeChild(coin));
        this.prevStepIdx = null;
    }    

    hasCounterNum(){
        return this.uiPopup.$popup.find('[data-interest-num]');
    }

    onSetStatus(el, value){
        const element = typeof el == 'object' ? el : this.uiPopup && this.uiPopup.el.querySelector(el);
        element && (element.style.display = value);
    }

    onSwipeHandler(event){
        // console.log('onSwipeHandler event:',event)
        if(event.target != this.swipeBtn) {
            return false;
        }
        
        if(event.type === 'touchstart'){
            this.defaults.repeatBounce == 'true' && this.stopBounce();
        }
        if(event.type === 'touchstart' || event.type === 'touchmove'){
            const currentPos = event.changedTouches[0].pageX - this.defaults.drags.dx - this.defaults.drags.rect.width/2;
            this.swipeDirection = currentPos > this.defaults.drags.cx ? 'right' : 'left';
            this.defaults.drags.cx = currentPos < 0 ? 0 : currentPos; 
        }
        if(event.type === 'touchmove'){
            if(this.defaults.drags.cx > 0){
                this.swipeBtn.classList.remove('bounce-in');
                this.swipeBtn.classList.add('active');
                this.swipeArea.parentElement.classList.add('active');
            }else{
                this.swipeBtn.classList.remove('active');
                this.swipeArea.parentElement.classList.remove('active');
            }

            if(this.swipeBtn.classList.contains('active')){
                // console.log(`cx:${this.defaults.drags.cx}`, `pageX:${event.changedTouches[0].pageX}`, `width:${this.defaults.drags.rect.width/2}`);

                // Drag 범위 정의
                if(this.defaults.drags.cx < this.defaults.drags.range[0]){  // 왼쪽 drag 임계점 
                    this.swipeBtn.style.transform = `translateX(${this.defaults.drags.range[0]}px)`;
                    // this.swipeArea.style.left = `${this.defaults.drags.range[0]}px`;
                }else if(this.defaults.drags.cx > this.defaults.drags.range[1]){  // 오른쪽 drag 임계점 
                    this.swipeBtn.style.transform = `translateX(${this.defaults.drags.range[1]}px)`;
                    this.swipeArea.style.left = `${this.defaults.drags.range[1]+this.defaults.drags.rect.width/2}px`;
                    // console.log('drag end...');
                }else{
                    this.swipeBtn.style.transform = `translateX(${this.defaults.drags.cx}px)`;
                    this.swipeArea.style.left = this.defaults.drags.cx > 0 && `${this.defaults.drags.cx+this.defaults.drags.rect.width/2}px`;
                    if(this.defaults.swipeStep && this.defaults.swipeStep.length){
                        this.swipeDirection == 'right' && this.coinEffectsInSlide();
                    }
                }
            }
        }
        if(event.type === 'touchend'){
            console.log('touchend2')
            if(this.touchEvents.start && !this.touchEvents.move) return false;

            this.swipeBtn.classList.remove('active');
            this.$el.off(`touchmove${this.eventId}`, this.swipeBtn, this.onSwipeHandler);
            this.reflow = true;
            this.isSlideComplete = Number(this.defaults.drags.cx > this.defaults.drags.ratio);   // 70% 이상이면 1, 미만이면 0
            this.slideRender();
        }
    }

    slideRender(){
        let that = this;

        if(that.reflow){
            if(that.isSlideComplete){    //70% 이상일 경우 좌표 보정
                if(that.defaults.drags.cx > that.defaults.drags.range[that.isSlideComplete] - 10){
                    that.defaults.drags.cx = that.defaults.drags.range[that.isSlideComplete];
                }
            }

            const currentPos = parseInt(that.defaults.drags.cx + (that.defaults.drags.range[that.isSlideComplete] - that.defaults.drags.cx) * that.defaults.drags.acc);
            that.swipeDirection = currentPos > that.defaults.drags.cx ? 'right' : 'left';           
            that.defaults.drags.cx = currentPos;

            that.swipeBtn.classList.add('active');
            that.swipeBtn.style.transform = `translateX(${that.defaults.drags.cx}px)`;
            that.swipeArea.style.left = `${that.defaults.drags.cx+that.defaults.drags.rect.width/2}px`;
            // that.swipeArea.style.left = `${that.defaults.drags.cx}px`;

            if(that.defaults.swipeStep && that.defaults.swipeStep.length){
                that.swipeDirection == 'right' && that.coinEffectsInSlide();
            }
            that.rafId = requestAnimationFrame(that.slideRender.bind(that));
        }

        if(that.defaults.drags.cx == that.defaults.drags.range[that.isSlideComplete]){
            cancelAnimationFrame(that.rafId);
            that.reflow = false;
            that.$el.on(`touchmove${that.eventId}`, that.swipeBtn, that.onSwipeHandler.bind(that));
            // console.log('that',that.isSlideComplete, that.isSlideComplete == true)
            if(that.isSlideComplete){
                if (that.onSlideComplete && $.isFunction(that.onSlideComplete)) {
                    that.onSlideComplete();  // 슬라이드 완료 후 콜백호출
                }
                that.slideCompleteCallback();
                // console.log(11111,that.swipeArea.parentElement.style.display)
                that.swipeArea.parentElement.style.display = 'none';
                // console.log('슬라이드 완료...');
            }else{    
                that.isTouchEvent = false;
                that.swipeBtn.classList.remove('active');
                that.swipeArea.parentElement.classList.remove('active');
                that.swipeArea.style.left = `${that.defaults.drags.range[0]}px`;
                (this.defaults.swipeStep && this.defaults.swipeStep.length) && that.removeCoins();
                that.defaults.repeatBounce == 'true' && that.startBounce();
                // console.log('처음으로 되돌아감...');
            }
        }
    }

    /* 밀어서 이자받기 slide Callback
        $($0).data('ui').slideCompleteCallback(function(){
            // console.log('밀어서 이자받기 슬라이드 종료...');
            // console.log('이자받기 정산 시작...');
        });
    */
    slideCompleteCallback(callback){
        if (callback && $.isFunction(callback)){
            this.onSlideComplete = callback;            
            return false;
        }

        setTimeout(() => {
            this.onSetStatus(this.swipeBtn, 'none');
            if(this.uiPopup){
                this.onSetStatus('.interest-group-after', 'flex');
                this.hasLottie().length && this.switchLottie();
                this.uiPopup.detachPopupEvents();
            }
            // console.log('슬라이드 완료');
            /*! s: FETASK-a11y page 밀어서 이자받기 접근성 추가 v.1.0.0 */
            isA11yCheckVersion() && this.isA11ySlideLiveText('end');
            /*! e: FETASK-a11y page 밀어서 이자받기 접근성 추가 v.1.0.0 */

            // 이자받기 정산 완료 후 풀팝업 전환
            // if (this.onCalcComplete && $.isFunction(this.onCalcComplete)) {
            //     this.open(this.onCalcComplete)
            // }

            // 이자받기 정산 실패시
            // if (this.onCalcFailure && $.isFunction(this.onCalcFailure)) {
            //     setTimeout(() => {
            //         this.onCalcFailure();
            //     }, 1000);
            // }
        }, 100)
    }

    slideActionCallback(callback){
        if (callback && $.isFunction(callback)){
            this.onActionComplete = callback;
        }
    }

    getInterestSuccess(callback){
        if (callback && $.isFunction(callback)){
            this.onCalcComplete = callback;
        }
        this.open(this.onCalcComplete);
    }

    getInterestFailure(callback){
        if (callback && $.isFunction(callback)){
            this.onCalcFailure = callback;
            setTimeout(() => this.onCalcFailure(), 100);
        }
    }

    open(callback = () => {        
    }) {
        setTimeout(() => {
            callback();
            this.hasLottie().length && this.uiLottie.defaults.lottieAni.play();
            this.onSetStatus('.interest-group-after', 'none');
            this.uiPopup.changeToFull();
            // setTimeout(() => {
            //     this.playLottie();
            // },1000);
        }, 100);
    }

    close(target) {
    }

    detachEvents() {
        this.$el.off(this.eventId);
    }

    destroy() {
        this.detachEvents();
    }
    deviceCheck () {
        let android
        if(navigator.userAgent.match(/iPhone|iPad|iPod/i)){
			android = false;
		}else{
			android = true
		}
        return android
    }
    /*! s: FETASK-a11y page 밀어서 이자받기 접근성 추가 v.1.0.0 */
    isA11yCreateSlideLiveArea(){
        const newArea = document.createElement('div');

        newArea.setAttribute('aria-live','assertive');
        newArea.setAttribute('aria-atomic','false');
        newArea.setAttribute('aria-relevant','additions text');
        newArea.classList.add('slide-live');
        document.querySelector('body').append(newArea);
    }

    async isA11ySlideLiveText(type='start'){
        /**
         * @param type start(시작) | end(슬라이드 완료)
         */
        try {
            const createText = document.createElement('div');

            const moneyText = document.querySelector('.txt-count-wrap > span');

            const textCount = 150;
            const delayTime = moneyText.textContent?.length  ? textCount * `${moneyText?.textContent} 받는 중`?.length : 1500;
            
            if(type === 'start'){
                createText.classList.add('slide-text');
                createText.innerHTML = `${moneyText.textContent} 받는 중`;
                document.querySelector('.slide-live').append(createText);
            }else if(type === 'end'){
                const delay = new Promise((resolve) => setTimeout(resolve, delayTime));

                await delay;


                const slideText = document.querySelectorAll('.slide-text');

                slideText.forEach((list) => { 
                    list.remove();
                });

                createText.innerHTML = '받기 완료';

                document.querySelector('.slide-live').append(createText);

                const activeEventPopup = document.querySelector('.activePopup.plus-box-event-pop .popup-content');
                const coinBottomToUp = document.querySelectorAll('.activePopup.plus-box-event-pop .coin-bottom-to-up');
                activeEventPopup && activeEventPopup?.setAttribute('aria-hidden','true');
                const removeClose = document.querySelector('.activePopup.plus-box-event-pop .close-btn');

                const focusTextWrap = document.querySelector('.activePopup.plus-box-event-pop .step2 .txt-count-wrap');

                const setep2Button = document.querySelector('.activePopup.plus-box-event-pop .ui-swipeAction');
                const plusBoxLayer = document.querySelectorAll('.activePopup.plus-box-event-pop .plus-box-layer');

                removeClose && removeClose.remove();

                coinBottomToUp && coinBottomToUp?.forEach((list) => {
                    list?.setAttribute('aria-hidden','true');
                });
                

                if(focusTextWrap){
                    focusTextWrap?.setAttribute('aria-hidden','false');
                    focusTextWrap?.setAttribute('tabindex','0');
                    focusTextWrap?.focus();
                }

                setep2Button && setep2Button?.setAttribute('title','확인');

                plusBoxLayer && plusBoxLayer?.forEach((list) => {
                    list?.setAttribute('aria-hidden','true');
                });

                setTimeout(() => {
                    createText.remove();
                },2000);
            }
        } catch (error) {
            throw new Error(error);
        }
    }
    /*! e: FETASK-a11y page 밀어서 이자받기 접근성 추가 v.1.0.0 */
}

export default SwipeToAction;